// src/pages/DonationPage.js
import React, { useState } from 'react';
import { useWallet, useConnection } from '@solana/wallet-adapter-react';
import {
    PublicKey,
    SystemProgram,
    Transaction,
    LAMPORTS_PER_SOL,
} from '@solana/web3.js';

// TODO: put your dev wallet address here
const DONATION_ADDRESS = new PublicKey('Div3RQvTo4JXaoRsPfTxP8K96c3tYVpMk3ksyVgHG2St');

// Optional: if you're on devnet, change this
const SOLSCAN_BASE_URL = 'https://solscan.io/tx/';
// const SOLSCAN_BASE_URL = 'https://solscan.io/tx/?cluster=devnet';

export default function DonationPage() {
    const { publicKey, sendTransaction, connected } = useWallet();
    const { connection } = useConnection();

    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [txSig, setTxSig] = useState('');

    const handleDonate = async () => {
        setError('');
        setTxSig('');

        if (!connected || !publicKey) {
            setError('Please connect a Solana wallet to make a donation.');
            return;
        }

        let sol = parseFloat(amount);
        if (isNaN(sol) || sol <= 0) {
            setError('Please enter a valid amount of SOL.');
            return;
        }

        try {
            setLoading(true);

            const lamports = Math.round(sol * LAMPORTS_PER_SOL);

            const tx = new Transaction().add(
                SystemProgram.transfer({
                    fromPubkey: publicKey,
                    toPubkey: DONATION_ADDRESS,
                    lamports,
                })
            );

            const sig = await sendTransaction(tx, connection);
            await connection.confirmTransaction(sig, 'confirmed');

            setTxSig(sig);
            setAmount('');
        } catch (e) {
            console.error(e);
            setError(e?.message || 'Donation failed.');
        } finally {
            setLoading(false);
        }
    };

    const quickSet = (value) => {
        setAmount(value.toString());
    };

    return (
        <div
            style={{
                maxWidth: 480,
                margin: '40px auto',
                padding: 24,
                borderRadius: 16,
                border: '1px solid rgba(255,255,255,0.1)',
                background: 'rgba(0,0,0,0.35)',
                backdropFilter: 'blur(8px)',
            }}
        >
            <h1 style={{ marginBottom: 8 }}>Support the Explorer</h1>
            <p style={{ opacity: 0.85, marginBottom: 16 }}>
                Send a small SOL tip to support ongoing development of this Solana NFT
                explorer and keep the RPCs running. 💚
            </p>

            <p style={{ fontSize: 14, opacity: 0.8, wordBreak: 'break-all' }}>
                <strong>Developer address:</strong>
                <br />
                {DONATION_ADDRESS.toBase58()}
            </p>

            <div style={{ marginTop: 16, marginBottom: 8 }}>
                <label htmlFor="donation-amount" style={{ display: 'block', marginBottom: 4 }}>
                    Amount (SOL)
                </label>
                <input
                    id="donation-amount"
                    type="number"
                    min="0"
                    step="0.000001"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    disabled={loading}
                    style={{
                        width: '100%',
                        padding: '8px 10px',
                        borderRadius: 8,
                        border: '1px solid rgba(255,255,255,0.2)',
                        background: 'rgba(0,0,0,0.4)',
                        color: 'white',
                    }}
                />
            </div>

            <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
                {[0.05, 0.1, 0.5, 1].map((val) => (
                    <button
                        key={val}
                        type="button"
                        onClick={() => quickSet(val)}
                        disabled={loading}
                        style={{
                            flex: '0 0 auto',
                            padding: '4px 10px',
                            borderRadius: 999,
                            border: '1px solid "mediumseagreen"',
                            background: 'transparent',
                            cursor: 'pointer',
                            color: 'white',
                        }}
                    >
                        {val} SOL
                    </button>
                ))}
            </div>

            <button
                type="button"
                onClick={handleDonate}
                disabled={loading || !amount}
                style={{
                    width: '100%',
                    padding: '10px 16px',
                    borderRadius: 999,
                    border: 'none',
                    cursor: loading ? 'default' : 'pointer',
                    fontWeight: 600,
                    fontSize: 16,
                    background:
                        'linear-gradient(135deg, rgba(45,212,191,1) 0%, rgba(56,189,248,1) 100%)',
                    color: '#000',
                }}
            >
                {loading ? 'Processing…' : 'Donate in SOL'}
            </button>

            {!connected && (
                <p style={{ marginTop: 12, fontSize: 13, color: '#f97373' }}>
                    Connect your wallet using the wallet adapter to donate.
                </p>
            )}

            {error && (
                <p style={{ marginTop: 12, fontSize: 13, color: '#f97373' }}>
                    {error}
                </p>
            )}

            {txSig && (
                <p style={{ marginTop: 12, fontSize: 13 }}>
                    Thank you! 🎉 View your transaction on Solscan:{' '}
                    <a
                        href={`${SOLSCAN_BASE_URL}${txSig}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: '#38bdf8' }}
                    >
                        {txSig.slice(0, 8)}…{txSig.slice(-8)}
                    </a>
                </p>
            )}
        </div>
    );
}
